import { get } from "../../utils/axiosInstance";

const BASE_URL = "/rest/reports";

export const fetchInventories = (
  page,
  active,
  item = null,
  station = null,
  brand = null,
  is_ingredient = null,
  from = null,
  plant = null,
  lot = null,
  location = null,
  grade = null,
) => {
  let url = `/rest/inventory/inventory/?page=${page}&active=${active}`;
  if (item) url += `&item=${item}`;
  if (brand) url += `&brand=${brand}`;
  if (station) url += `&station=${station}`;
  if (from) url += `&from=${from}`;
  if (is_ingredient) url += `&is_ingredient=${is_ingredient}`;
  if (plant) url += `&plant=${plant}`;
  if (lot) url += `&vendor_lot_number=${lot}`;
  if (location) url += `&location=${location}`;
  if (grade) url += `&grade=${grade}`;
  return get(url);
};

export const fetchIngredientsReportCSV = (
  item = null,
  station = null,
  brand = null,
  is_ingredient = null,
  active = null,
  plant = null,
  lot = null
) => {
  let url = `/rest/inventory/inventory/export_csv/?`;
  if (active) url += `&active=${active}`;
  if (item) url += `&item=${item}`;
  if (brand) url += `&brand=${brand}`;
  if (station) url += `&station=${station}`;
  if (is_ingredient) url += `&is_ingredient=${is_ingredient}`;
  if (plant) url += `&plant=${plant}`;
  if (lot) url += `&vendor_lot_number=${lot}`;
  return get(url, { responseType: "arraybuffer" });
};

export const fetchInventoriedItems = (page, search = null, plant = null, lot = null, station = null) => {
  let url = `/rest/inventory/inventory/inventoried_items/?page=${page}`;
  if (search) url += `&search=${search}`;
  if (plant) url += `&plant=${plant}`;
  if (lot) url += `&vendor_lot_number=${lot}`;
  if (station) url += `&station=${station}`;
  return get(url);
};

export const fetchInventoriedItemsCSV = (search = null, plant = null, lot = null, station = null) => {
  let url = `/rest/inventory/inventory/inventoried_items/?page_size=0`;
  if (search) url += `&search=${search}`;
  if (plant) url += `&plant=${plant}`;
  if (lot) url += `&vendor_lot_number=${lot}`;
  if (station) url += `&station=${station}`;
  return get(url);
};

export const fetchShipmentReport = (page, from = null, to = null, search = null, customer = null, plant = null, lot = null, shipment_id = null) => {
  let url = `${BASE_URL}/shipment/?page=${page}&search=${search}`;
  if (from) url += `&from_date=${from}`;
  if (to) url += `&to_date=${to}`;
  if (customer) url += `&customer=${customer}`;
  if (plant) url += `&plant=${plant}`;
  if (lot) url += `&vendor_lot_number=${lot}`;
  if (shipment_id) url += `&shipment_id=${shipment_id}`;
  return get(url);
};

export const fetchShipmentReportCSV = (from = null, to = null, search = "", customer = null, plant = null, lot = null, shipment_id = null) => {
  let url = `${BASE_URL}/shipment/export_csv?&search=${search}`;
  if (from) url += `&from_date=${from}`;
  if (to) url += `&to_date=${to}`;
  if (customer) url += `&customer=${customer}`;
  if (plant) url += `&plant=${plant}`;
  if (lot) url += `&vendor_lot_number=${lot}`;
  if (shipment_id) url += `&shipment_id=${shipment_id}`;
  return get(url, { responseType: "arraybuffer" });
};

export const fetchShipmentReportCSV_R365 = (from = null, to = null, search = "") => {
  let url = `${BASE_URL}/shipment/export_csv_R365?&search=${search}`;
  if (from && to) {
    url += `&from_date=${from}&to_date=${to}`;
  } else if (to) {
    url += `&to_date=${to}`;
  } else if (from) {
    url += `&from_date=${from}`;
  }
  return get(url, { responseType: "arraybuffer" });
};

export const fetchShipmentReportCSV_R365_2 = (from = null, to = null, search = "") => {
  let url = `${BASE_URL}/shipment/export_csv_R365_2?&search=${search}`;
  if (from && to) {
    url += `&from_date=${from}&to_date=${to}`;
  } else if (to) {
    url += `&to_date=${to}`;
  } else if (from) {
    url += `&from_date=${from}`;
  }
  return get(url, { responseType: "arraybuffer" });
};

export const fetchInvoiceReport = (page, from, to, search) => {
  const url = `${BASE_URL}/invoice_reports/?page=${page}&from_date=${from}&to_date=${to}${search ? "&search=" + search : ""}`;
  return get(url);
};

export const fetchInvoiceReportCSV = (from, to) => {
  const url = `${BASE_URL}/invoice_reports/?page_size=0&from_date=${from}&to_date=${to}`;
  return get(url);
};

export const fetchProductionReport = (
  page, search = null, from = null, to = null,
  station = null, parent_Child = null, plant = null, lot = null
) => {
  let url = `${BASE_URL}/production_report/?page=${page}`;
  if (search) url += `&search=${search}`;
  if (station !== null) url += `&session__station__id=${station}`;
  if (from) url += `&from=${from}`;
  if (to) url += `&to=${to}`;
  if (parent_Child) url += `&parent_Child=${parent_Child}`;
  if (plant) url += `&plant=${plant}`;
  if (lot) url += `&vendor_lot_number=${lot}`;
  return get(url);
};

export const fetchProductionReportCSV = (
  search = null, from = null, to = null, station = null,
  parent_Child = null, plant = null, lot = null
) => {
  let url = `${BASE_URL}/production_report/export_csv/?`;
  if (search) url += `&search=${search}`;
  if (from) url += `&from=${from}`;
  if (to) url += `&to=${to}`;
  if (station !== null) url += `&session__station__id=${station}`;
  if (parent_Child) url += `&parent_Child=${parent_Child}`;
  if (plant) url += `&plant=${plant}`;
  if (lot) url += `&vendor_lot_number=${lot}`;
  return get(url, { responseType: "arraybuffer" });
};

export const fetchInventoryWasteReport = (page, search = null, from = null, to = null, category = null, plant = null, lot = null) => {
  let url = `${BASE_URL}/inventory_waste/?page=${page}`;
  if (search) url += `&search=${search}`;
  if (category !== null) url += `&waste_category__id=${category}`;
  if (from) url += `&from=${from}`;
  if (to) url += `&to=${to}`;
  if (plant) url += `&plant=${plant}`;
  if (lot) url += `&vendor_lot_number=${lot}`;
  return get(url);
};

export const fetchInventoryWasteReportCSV = (search = null, from = null, to = null, category = null, plant = null, lot = null) => {
  let url = `${BASE_URL}/inventory_waste/?page_size=0`;
  if (search) url += `&search=${search}`;
  if (category !== null) url += `&waste_category__id=${category}`;
  if (from) url += `&from=${from}`;
  if (to) url += `&to=${to}`;
  if (plant) url += `&plant=${plant}`;
  if (lot) url += `&vendor_lot_number=${lot}`;
  return get(url);
};

export const fetchYieldReport = (page, search = null, from = null, to = null, station = null) => {
  let url = `${BASE_URL}/yield/?page=${page}`;
  if (search) url += `&search=${search}`;
  if (station !== null) url += `&station__id=${station}`;
  if (from) url += `&from=${from}`;
  if (to) url += `&to=${to}`;
  return get(url);
};

export const fetchYieldReportCSV = (search = null, from = null, to = null, station = null) => {
  let url = `${BASE_URL}/yield/?page_size=0`;
  if (search) url += `&search=${search}`;
  if (station !== null) url += `&station__id=${station}`;
  if (from) url += `&from=${from}`;
  if (to) url += `&to=${to}`;
  return get(url);
};

export const fetchAverageYield = (id, fromDate, toDate) => {
  const url = `/rest/inventory/production_session/${id}/average_yield/?from_avg=${fromDate}&to_avg=${toDate}`;
  return get(url);
};

export const fetchExpiredInventoriesReport = (page, search = null, from = null, to = null, location = null, plant = null, lot = null) => {
  let url = `${BASE_URL}/expired_inventories/?page=${page}`;
  if (search) url += `&search=${search}`;
  if (location !== null) url += `&current_location__id=${location}`;
  if (from) url += `&from=${from}`;
  if (to) url += `&to=${to}`;
  if (plant) url += `&plant=${plant}`;
  if (lot) url += `&vendor_lot_number=${lot}`;
  return get(url);
};

export const fetchExpiredInventoriesReportCSV = (search = null, from = null, to = null, location = null, plant = null, lot = null) => {
  let url = `${BASE_URL}/expired_inventories/?page_size=0`;
  if (search) url += `&search=${search}`;
  if (location !== null) url += `&current_location__id=${location}`;
  if (from) url += `&from=${from}`;
  if (to) url += `&to=${to}`;
  if (plant) url += `&plant=${plant}`;
  if (lot) url += `&vendor_lot_number=${lot}`;
  return get(url);
};

export const fetchWeightedPriceReport = (page, plant = null, lot = null) => {
  let url = `/rest/inventory/inventory/weighted_price_report/?page=${page}`;
  if (plant) url += `&plant=${plant}`;
  if (lot) url += `&vendor_lot_number=${lot}`;
  return get(url);
};

export const fetchWeightedPriceReportCSV = (plant = null, lot = null) => {
  let url = "/rest/inventory/inventory/weighted_price_report/?page_size=0";
  if (plant) url += `&plant=${plant}`;
  if (lot) url += `&vendor_lot_number=${lot}`;
  return get(url);
};

export const fetchReceivingReport = (page, date = null, vendor_id = null, lot = null) => {
  let url = `${BASE_URL}/receiving_reports/?page=${page}`;
  if (date) url += `&date=${date}`;
  if (vendor_id) url += `&vendor_id=${vendor_id}`;
  if (lot) url += `&vendor_lot_number=${lot}`;
  return get(url);
};

export const fetchReceivingReportCSV = (date = null, vendor_id = null, lot = null) => {
  let url = `${BASE_URL}/receiving_reports/export_csv/?`;
  if (date) url += `&date=${date}`;
  if (vendor_id) url += `&vendor_id=${vendor_id}`;
  if (lot) url += `&vendor_lot_number=${lot}`;
  return get(url, { responseType: "arraybuffer" });
};

export const getReceivingReportPdf = (date = null, vendor_id = null, lot = null) => {
  let url = `${BASE_URL}/receiving_reports/print_pdf/?`;
  if (date) url += `&date=${date}`;
  if (vendor_id) url += `&vendor_id=${vendor_id}`;
  if (lot) url += `&vendor_lot_number=${lot}`;
  return get(url, { responseType: "arraybuffer" });
};
